<template>
  <div>
    <b-container fluid class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">News & Data</div>
            <!-- <b-breadcrumb :items="items"></b-breadcrumb> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
    <news-data></news-data>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import NewsData from "@/components/NewsData.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "News Detail";
  },
  name: "Newsdetail",
  data() {
    return {
      drawer: true,
      images: {
        headImage: require("@/assets/bgparallax-01.jpg")
      },
      data: [],
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Media",
          href: "/news",
          active: true
        }
      ]
    };
  },
  components: {
    "news-data": NewsData,
    "call-us": CallUs
  }
};
</script>
<style scoped></style>
